export default function Footer() {
  return (
    <footer className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-8 lg:px-8">
        <p className="text-center text-sm text-gray-600">
          &copy; 2023 Despega, All rights reserved.
        </p>
      </div>
    </footer>
  )
}
